<template>
  <div class="row ficha-autor">
    <div class="col">
      <h1 class="subtitle">Acerca de </h1>
      <p>La <em>Antolog&iacute;a Lit(e)Lat volumen 1</em> se ha propuesto como un espacio de recuperaci&oacute;n y
        visibilizaci&oacute;n de un corpus significativo de piezas de literatura electr&oacute;nica producidas desde (o
        en relaci&oacute;n con) Latinoam&eacute;rica y el Caribe. Consideramos como literatura electr&oacute;nica obras
        de arte textual que experimentan con dispositivos electr&oacute;nicos digitales y, en casos hist&oacute;ricos,
        anal&oacute;gicos. Este tipo de literatura, aunque frecuentemente incorpora imagen fija o en movimiento, video,
        sonido, programaci&oacute;n, interacci&oacute;n, redes, requiere un alto grado de participaci&oacute;n del
        lenguaje verbal con funci&oacute;n po&eacute;tica.</p>
      <p>En cuanto se trata de una antolog&iacute;a latinoamericana y caribe&ntilde;a, un desaf&iacute;o importante ha
        sido la identificaci&oacute;n de los l&iacute;mites de la regi&oacute;n teniendo en cuenta los frecuentes
        desplazamientos y migraciones que involucran a quienes han elaborado las piezas. As&iacute; en relaci&oacute;n
        con el pa&iacute;s con el que se identifica cada obra, tomamos como pauta el lugar de nacimiento de cada
        artista, incluyendo en casi todos los casos artistas que nacieron en Latinoam&eacute;rica y el Caribe o, en su
        defecto, cuya vinculaci&oacute;n con Latinoam&eacute;rica resulta fundamental para la pieza que publicamos.
        Estas vinculaciones nos acercan a producciones que representan a los siguientes pa&iacute;ses: Argentina,
        Brasil, Chile, Colombia, Cuba, la comunidad latina en Estados Unidos, M&eacute;xico, Per&uacute;, Trinidad y
        Tobago, Uruguay y Venezuela. Nuestra antolog&iacute;a tambi&eacute;n representa la diversidad ling&uuml;&iacute;stica
        de la regi&oacute;n y sus hegemon&iacute;as con obras en espa&ntilde;ol, franc&eacute;s, ingl&eacute;s, portugu&eacute;s,
        quechua y zapoteco.&nbsp;</p>
      <p>Por otra parte, determinar la autor&iacute;a misma de cada pieza ha sido en ocasiones tambi&eacute;n un desaf&iacute;o,
        dada la gran problematizaci&oacute;n que al respecto implica la literatura electr&oacute;nica. En los casos en
        que una obra se presenta a s&iacute; misma en coautor&iacute;a entre quien la ha ideado, escrito o dise&ntilde;ado
        y quien la ha programado, la consideramos como de autor&iacute;a compartida. Cuando no se presenta de esta
        manera, consideramos la autor&iacute;a de quien se presenta como tal y en el comentario editorial espec&iacute;fico
        consignamos los nombres de quienes colaboraron.</p>
      <p>Al ser &eacute;sta la primera antolog&iacute;a de literatura electr&oacute;nica en la regi&oacute;n, buscamos
        capturar la historia del campo al incorporar obras pioneras y recientes. Adem&aacute;s quisimos reflejar la
        trayectoria de artistas con mayor presencia, en cuyos casos hemos incluido m&uacute;ltiples piezas. Las fechas
        que damos para cada pieza son las de su lanzamiento, duraci&oacute;n, remediaci&oacute;n y/o nuevas versiones.&nbsp;</p>
      <p>Dado que las fechas de las obras compiladas van de 1965 a 2019, sus formatos var&iacute;an ampliamente,
        incluyendo tecnolog&iacute;as hoy obsoletas. El caso m&aacute;s reciente de obsolescencia es el formato Flash,
        que la compa&ntilde;&iacute;a Adobe ha decidido discontinuar a partir del 31 de diciembre de 2020. Hay obras que
        han migrado de la tecnolog&iacute;a en la que fueron inicialmente realizadas a otras m&aacute;s contempor&aacute;neas,
        en algunos casos transform&aacute;ndose en nuevas versiones. Para maximizar el acceso a las obras, hemos
        utilizado varias estrategias, como la inclusi&oacute;n de m&uacute;ltiples versiones, documentaci&oacute;n en
        video, archivos descargables, enlaces a emulaciones y <em>porting</em> a lenguajes de programaci&oacute;n y
        formatos actualizados.</p>
      <p>La antolog&iacute;a est&aacute; organizada por autor&iacute;a, a&ntilde;o, pa&iacute;s, tecnolog&iacute;as y
        categor&iacute;as descriptivas. Estas categor&iacute;as representan tendencias y pr&aacute;cticas del campo de
        la literatura electr&oacute;nica, por ejemplo: obras aleatorias o generativas, poes&iacute;a animada y/o sonora,
        hipertexto e hipermedia, memes, videojuegos, etc. El men&uacute; de inicio incluye, adem&aacute;s de accesos seg&uacute;n
        a&ntilde;o, autor&iacute;a, pa&iacute;s, obras y categor&iacute;as, un acceso llamado &ldquo;descubrir&rdquo;
        para llegar a las obras en forma aleatoria. La metadata tambi&eacute;n permite la exploraci&oacute;n de obras
        con caracter&iacute;sticas y tecnolog&iacute;as en com&uacute;n. Hemos creado adem&aacute;s un bot en Twitter
        (<a href="https://twitter.com/AntologiaBot">@AntologiaBot</a>) que hace recomendaciones aleatoriamente.</p>
      <p>La literatura electr&oacute;nica latinoamericana y caribe&ntilde;a es a la vez localizada y de-localizada. Esta
        condici&oacute;n habla de un espacio de tensiones globales y nacionales. Por un lado, es una literatura
        dependiente del desarrollo global inform&aacute;tico. Pero, por otro lado, se trata tambi&eacute;n de una
        literatura que presenta con bastante frecuencia especificidades locales en cuanto a una fuerte comprensi&oacute;n
        de relaciones de poder y asimetr&iacute;as, hegemon&iacute;as de sentidos en las culturas digitales, e
        idiosincrasias y tem&aacute;ticas vinculadas con procesos socio-hist&oacute;ricos, pol&iacute;ticos y econ&oacute;micos
        de la regi&oacute;n. Todo esto da cuenta de una tendencia hacia la politizaci&oacute;n de esta pr&aacute;ctica
        no solamente a nivel de los contenidos sino tambi&eacute;n de las pol&iacute;ticas ling&uuml;&iacute;sticas y
        algor&iacute;tmicas. Asimismo, otra tendencia que recorre en buena medida la literatura electr&oacute;nica
        latinoamericana y caribe&ntilde;a se vincula con las genealog&iacute;as experimentales de poes&iacute;a visual,
        sonora, perform&aacute;tica de la regi&oacute;n que se enlazan con la creaci&oacute;n digital.</p>
      <p>Vemos esta antolog&iacute;a como una instant&aacute;nea que captura y enfoca una parte significativa del estado
        e historial del campo seg&uacute;n lo hemos podido percibir en este momento. Esto est&aacute; necesariamente
        limitado al alcance de la comunidad Lit(e)Lat, una red emergente con voces art&iacute;sticas y acad&eacute;micas
        a trav&eacute;s de Latinoam&eacute;rica, el Caribe y el mundo. Esperamos que este primer volumen, motive a la
        comunidad a continuar descubriendo otras piezas de literatura electr&oacute;nica de la regi&oacute;n e inspire
        la creaci&oacute;n de nuevas obras que queden capturadas en vol&uacute;menes subsiguientes.</p>
      <h1 class="subtitle">Comité editorial </h1>
      <p>
        Leonardo Flores<br>
        Claudia Kozak<br>
        Rodolfo Mata
      </p>

      <h1 class="subtitle">Desarrollo </h1>
      <p class="desarrollo">
        <strong>Diseño</strong>: <a href="http://entalpia.pe/" target="_blank">José Aburto</a><br>
        <strong>Base del maquetado HTML</strong>:  <!--<a href="http://www.eikondesign.com.ar/" target="_blank">-->Inés
        Sotomayor<!--</a>--><br>
        <strong>Programación</strong>: <a href="http://www.miltonlaufer.com.ar/" target="_blank">Milton Läufer</a>
      </p>
      <h1 class="subtitle">FICHA BIBLIOGRÁFICA</h1>
      <p>
      <p>Flores, Leonardo; Kozak, Claudia; Mata, Rodolfo (eds). <em>Antolog&iacute;a Lit(e)Lat Volumen 1</em>. Red de
        Literatura Electr&oacute;nica Latinoamericana, 2020, http://antologia.litelat.net</p>
      </p>
      <h1 class="subtitle">AUSPICIOS</h1>
      <p class="desarrollo">
        <a href="http://eliterature.org" target="_blank">Electronic Literature Organization (ELO) </a>
      </p>
      <h1 class="subtitle">Licencia</h1>
      <p class="desarrollo"><a href="https://creativecommons.org/licenses/by-nc/4.0/deed.es" target="_blank">Creative
        Commons Atribuci&oacute;n-NoComercial
        4.0 Internacional (CC BY-NC
        4.0)</a></p>
      <h1 class="subtitle">Código fuente</h1>
      <p class="desarrollo"><a href="https://github.com/miltonlaufer/litelat" target="_blank">Proyecto
        SPA (Single Page Application) desarrollado sobre el framework Vue.js. El código se distribuye gratuitamente bajo
        licencia MIT.<br>https://github.com/miltonlaufer/litelat</a></p>
      <h1 class="subtitle">Versión</h1>
      <p>1.0 - 30 de dicembre de 2020</p>
    </div>
  </div>
</template>

<script>
import mixins from "../misc/mixins";

export default {
  name: "Acerca.vue",
  mixins: [mixins],
  mounted() {
    this.$nextTick(() => {
      document.body.classList.add("ficha");
      document.getElementById('generalWrapper').classList.add('ficha-wrapper');
    });
  },
}
</script>

<style scoped>

</style>
